import { useEffect, useState } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import MedicalHistoryService from "../../../../Services/MedicalHistoryService";

export default function MedicalHistory({ patientId }) {
  return (
    <>
      <h1>Medical History</h1>
    </>
  );
}
